/**
 * @module builder
 */
import type { OptionsDocument, QuoteDocument } from 'paintscout'

import { removeItem } from './index'
import type { QuoteItemSection } from '../..'

export function removeItems(args: {
  quote: QuoteDocument
  options: OptionsDocument
  keys: string[]
  section?: QuoteItemSection
}): QuoteDocument {
  const { quote, options, keys, section } = args

  return keys.reduce(
    (updatedQuote: QuoteDocument, key: string) => {
      return removeItem({ quote: updatedQuote, options, key, section })
    },
    { ...quote }
  )

  return null
}
